import { API } from "../../config";
import axios from "axios";

export const updateUser = async (token, user) => {
  let data = {
    first_name: user.firstName,
    last_name: user.lastName,
    email: user.email,
    phone: user.phone,
    organization_name: user.organizationName,
    bank_accounts: user.bankAccounts,
  };
  const res = await axios.post(`${API}/v1/users`, data, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (res.data.success) {
    return res.data;
  } else {
    alert(res.data.error);
  }
};

export const updateUserOnLocal = (data, next) => {
  let existing = localStorage.getItem("jwt");
  // If no existing data, create an array
  // Otherwise, convert the localStorage string to an array
  existing = existing ? JSON.parse(existing) : {};
  // Add new data to localStorage Array
  let updatedUserInfo = {
    _id: existing.user._id,
    firstName: data.firstName || existing.firstName,
    lastName: data.lastName || existing.lastName,
    email: data.email || existing.email,
    phone: data.phone || existing.phone,
    courier: data.courier || existing.courier,
  };

  existing.user = updatedUserInfo;

  if (typeof window !== "undefined") {
    localStorage.setItem("jwt", JSON.stringify(existing));
    next();
  }
};

/**
 * @typedef {Object} User
 * @property {string} _id
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} email
 * @property {string} phone
 * @property {Object} courier
 * @property {string} courier.courierCode
 * @property {string} courier.courierType
 * @property {string} courier.status - approved, notApproved
 * @property {string} [courier.openCourierId]
 * @property {string} [courier.openCourierName]
 * @property {string} environment
 * @property {string} role
 * @property {Array} services
 * @property {string} source
 * @property {string} key
 * @property {boolean} verification_status
 * @property {Object} fulfillment_service_pricing
 * @property {number} fulfillment_service_pricing.storage_fee
 * @property {number} fulfillment_service_pricing.channel_fee
 * @property {boolean} fulfillment_service_pricing.new_packaging_system
 * @property {Object} fulfillment_service_configuration
 * @property {boolean} fulfillment_service_configuration.reject_out_of_stock_order
 */

/**
 * Get user data from server
 * @param {string} token - JWT token
 * @returns {Promise<{success: boolean, data: User}>} - User data
 */
export const getUser = (token) => {
  return fetch(`${API}/v1/getuser`, {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const submitNewPassword = (email, password) => {
  return fetch(`${API}/v1/new_password`, {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ email, password }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const forgotPasswordEmail = (email) => {
  return fetch(`${API}/v1/forgot_password`, {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ email }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};
